/* global document, rp$, window */

const {
	clearFacetCheckboxes,
	clearSelectedCategory,
	getFacetCheckboxes,
	getFacetCategories,
	getFacetValuesFromDom,
	updateSelectedFacetCheckboxes,
	disableFacets,
	enableFacets,
	constants,
} = require('public/js/components/search-facets');

const THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	function getFacetsModule() {
		return rp$('.search-facets-module');
	}

	function clearAllFilters() {
		clearFacetCheckboxes(true);
		clearSelectedCategory();
		handleFacetChange(true);
	}

	function handleFacetChange(useMobileFacets) {

		const requestParams = getFacetValuesFromDom(useMobileFacets);


		// Append search str. Append DSEO params if necessary
		const $facetsModule = getFacetsModule();
		const pageId = $facetsModule.data('page-id');
		const pageUrl = $facetsModule.data('page-url');
		requestParams.search_str = $facetsModule.data('search-str');
		if (pageId) { requestParams.page_id = pageId; }
		if (pageUrl) { requestParams.page_url = pageUrl; }

		$facetsModule.trigger('selectedFacetBucketsChanged', [requestParams]);
		disableFacets();
	}

	function handleCategoryFacetClick(event) {
		event.preventDefault();
		const el = event.target;
		if (!el.classList.contains(constants.ACTIVE_CATEGORY_CLASS)) {
			const facetCategories = getFacetCategories();
			facetCategories.forEach((categoryLink) => categoryLink.classList.remove(constants.ACTIVE_CATEGORY_CLASS));

			el.classList.add(constants.ACTIVE_CATEGORY_CLASS);

			// The mobile facets shouldn't trigger this on change/click, only when the 'Apply' button is clicked
			if (! el.classList.contains('mobile')) {
				handleFacetChange(false);
			}
		}
	}

	$onReady({
		rp$,
		window,
		label: 'search_facets',
		fn: function () {
			const facetsModule = getFacetsModule();
			const multiSelectFacetCheckboxes = getFacetCheckboxes();

			const facetCategories = getFacetCategories();
			const mobileFiltersApplyButton = rp$('#mobile-filters-apply-button');
			const mobileFiltersClearButton = rp$('#mobile-filters-clear-button');

			if (facetsModule) {
				multiSelectFacetCheckboxes.forEach((checkbox) => {
					checkbox.addEventListener('change', () => handleFacetChange(false));
				});

				facetCategories.forEach((categoryLink) => {
					categoryLink.addEventListener('click', handleCategoryFacetClick);
				});

				if (mobileFiltersApplyButton && mobileFiltersApplyButton.length) {
					rp$('#mobile-filters-apply-button').on('click', () => { handleFacetChange(true); });
				}

				if (mobileFiltersClearButton && mobileFiltersClearButton.length) {
					rp$('#mobile-filters-clear-button').on('click', () => { clearAllFilters(); });
				}
			}

			rp$(document).on('searchResults:response', (e, response={}) => {
				updateSelectedFacetCheckboxes(response.selected_facets);
				enableFacets();
			});
		},
	});
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
